import { Layout, Space, Typography } from "antd";
import React from "react";
import { useTranslation, Trans } from "react-i18next";
import { LOGO_SVG_URL } from "../constants/common";

const { Title } = Typography;

const FeedbackThanks = () => {
  const { Content, Header } = Layout;
  const { t } = useTranslation();
  return (
    <Layout className="bg-white">
      <Header className="welcome-footer bg-white">
        <img
          alt="Provider1st Logo"
          className="mt-4 mx-auto"
          src={window.location.origin + LOGO_SVG_URL}
        />
      </Header>
      <Content className="p-4 pb-0 md:p-6">
        <div className="container mx-auto followingl-list text-center md:text-left">
          <Space direction="vertical" className="w-full" size={30}>
            <Title
              level={1}
              className="font-bold text-center md:text-left"
              style={{
                fontSize: "1.5rem",
              }}
            >
              {t("common:feedback_thanks:thank_you")}
            </Title>
            <Title
              level={3}
              className="!font-normal text-center md:text-left"
              style={{
                fontSize: "0.938rem",
              }}
            >
              {t(
                "common:feedback_thanks:submitted_successfully"
              )}
            </Title>
          </Space>

          <Title
            level={3}
            className="mt-10 md:mt-10 text-center !font-semibold md:text-left"
            style={{  fontSize: "0.938rem" }}
          >
            <Trans
              i18nKey="common:feedback_thanks:assistance_call_text"
              components={{
                a: <a href="tel:855-514-2378" />,
                u: <u />,
              }}
            />
          </Title>
        </div>
      </Content>
    </Layout>
  );
};

export default FeedbackThanks;
